import { type ChangeEvent, useCallback, useMemo } from 'react'
import { useFormikContext } from 'formik'

import { getServiceLocationTitle } from '@sales-center/common'

import { LocAndSvcsFormModel } from '../formConfig'
import { LocationSelectProps } from './LocationSelect'

export function useLocationSelect(props: LocationSelectProps) {
  const { serviceLocations } = props

  const { setValues } = useFormikContext<LocAndSvcsFormModel>()

  const locationOptions = useMemo(
    () =>
      serviceLocations.map((l) => ({
        id: `${l.id}`,
        label: getServiceLocationTitle(l),
      })),
    [serviceLocations],
  )

  const onChange = useCallback(
    (event: ChangeEvent<HTMLTextAreaElement>) => {
      setValues(
        (values) => ({
          ...values,
          serviceType: null,
          serviceIds: new Map(),
          serviceLocationId: event.target.value,
        }),
        false,
      )
    },
    [setValues],
  )

  return {
    onChange,
    locationOptions,
  }
}
